import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { Trans, useTranslation } from 'react-i18next';

import useSignIn from '../../hooks/useSignIn';

function SignInForm() {
    const { t } = useTranslation('signIn');
    const {
        phoneNo, onChangeValue, smsAuthNo, onChangeCode, requestSms, requestVerify,
        requestColor, verityColor,
    } = useSignIn();
    const isEmail = useIsEmailSignIn();
    const placeholderKey = isEmail ? 'phone.emailPlaceholder'
        : 'phone.phonePlaceholder';
    const subtitleKey = isEmail ? 'phone.subtitleEmail' : 'phone.subtitle';
    const titleKey = isEmail ? 'phone.titleEmail' : 'phone.title';
    return (
        <Container fullWidth as='section' spacing={12}>
            <Text size='xl' fontWeight='bold'>{t(titleKey)}</Text>
            <CommentText color={colors.gray7}
                size='lg'
                fontWeight='bold' >
                {t(subtitleKey)}
            </CommentText>
            <Column fullWidth spacing={12}>
                <TextField value={phoneNo}
                    onChange={onChangeValue}
                    placeholder={t(placeholderKey)}
                    inputMode={isEmail ? 'email' : 'numeric'}
                    maxLength={isEmail ? 100 : 13}
                    trailing={
                        <ButtonWrapper type='button'
                            onClick={requestSms} >
                            <ButtonText fontWeight='bold' color={requestColor}>
                                {t('phone.requestCode')}
                            </ButtonText>
                        </ButtonWrapper>
                    } />
                <TextField value={smsAuthNo}
                    onChange={onChangeCode}
                    placeholder={t('phone.codePlaceholder')}
                    inputMode='numeric'
                    maxLength={6}
                    trailing={
                        <ButtonWrapper onClick={requestVerify}
                            type='button' >
                            <ButtonText fontWeight='bold' color={verityColor}>
                                {t('phone.verifyCode')}
                            </ButtonText>
                        </ButtonWrapper>
                    } />
            </Column>
            <Row spacing={6}>
                <Text color={colors.gray5}
                    size='s' >
                    <Trans ns='signIn'
                        i18nKey='phone.privacyConsignee'
                        components={{ b: <b/> }} />
                </Text>
                <Separator/>
                <Text color={colors.gray5}
                    size='s' >
                    <Trans ns='signIn'
                        i18nKey='phone.privacyPurpose'
                        components={{ b: <b/> }} />
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Column)`
    flex: 1;
    padding: 50px 20px 0;
`;

const CommentText = styled(Text)`
    margin-top: 12px;
`;

const ButtonWrapper = styled.button`
    padding: 8px 12px;
    background-color: transparent;
`;

const ButtonText = styled(Text)`
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 2px;
`;

const Separator = styled.div`
    background-color: var(--color-gray5);
    height: 8px;
    width: 1px;
`;

export default SignInForm;
